export const get = {
    method: 'GET',
    paths: [
        '/api/v2/activities',
        '/api/v2/customers',
        '/api/v2/customers/:customerId/orders',
        '/api/v2/orders',
        '/api/orgs/:orgId/locations/:locationId/guests/:guestId/orders',
    ],
    fields: {
        olderThan: {
            type: 'mongoId',
        },
    },
};
//# sourceMappingURL=paginated_list_get.js.map